import { createTheme, CssBaseline, Theme, ThemeProvider } from '@mui/material';
import { useTenantThemeQuery } from 'gql/index';
import { merge } from 'lodash';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { TenantThemeContextProvider } from './TenantThemeContextProvider';

export const TenantThemeProvider = ({ children }: { children: ReactNode; }) => {
  const { formatMessage } = useIntl();
  const { data: tenantTheme, isLoading } = useTenantThemeQuery(undefined, { select: d => d.tenantTheme });

  if (isLoading) {
    return undefined;
  }

  const title = tenantTheme?.isBrandingEnabled
    ? `${formatMessage({ id: 'Portal' })} - ${tenantTheme.name}`
    : 'Via Central';
  const description = tenantTheme?.isBrandingEnabled ? undefined : 'Bien plus qu\'un espace client';
  const faviconHref = tenantTheme?.isBrandingEnabled && tenantTheme?.faviconUrl
    ? tenantTheme.faviconUrl
    : '/favicon.png';

  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link id="favicon" rel="icon" type="image/png" href={faviconHref} />

      <ThemeProvider
        theme={(theme: Theme) => {
          if (!tenantTheme?.isBrandingEnabled) { return theme; }
          
          const newTheme = createTheme(merge({}, theme, {
            palette: {

              primary: {
                main: tenantTheme?.primaryColor || theme.palette.primary.main
              },
              secondary: {
                main: tenantTheme?.secondaryColor || theme.palette.secondary.main
              },
            },
            components: {
              MuiCssBaseline: {
                styleOverrides: {
                  body: {
                    '& ::-webkit-scrollbar': {
                      width: 8
                    },
                    '& ::-webkit-scrollbar-track': {
                      backgroundColor: 'rgba(0, 0, 0, 0.12)',
                    },
                    '& ::-webkit-scrollbar-thumb': {
                      backgroundColor: `${tenantTheme?.primaryColor || theme.palette.primary.main}`,
                    }
                  }
                }
              }
            }
          }));

          return newTheme;
        }}
      >
        <CssBaseline />
        
        <TenantThemeContextProvider tenantTheme={tenantTheme}>
          {children}
        </TenantThemeContextProvider>
      </ThemeProvider >
    </>
  );
};